<template>
  <div class="app-expert">
    <div class='u-flex'>
      <el-input v-model="listQuery.url" style="width: 300px" />
      <el-button :disabled="loading" class="button" style="margin-left: 20px" @click="handleRead">读取</el-button>
      <el-button :disabled="loading" class="button" @click="handleQuery">搜索</el-button>
    </div>
    <el-table
      v-loading='loading'
      :data="list"
      :header-cell-style="{
        background: '#E7ECF1',
        fontSize: '14px',
        color: 'rgba(0 ,0, 0, .85)'
      }"
    >
      <el-table-column label="达人">
        <template slot-scope="{row}">
          <div class="avatar-name">
            <el-avatar class="avatar" :src="row.avatar" :size="25" />
            <div class="name" :title="row.nickname">{{ row.nickname }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="分类" prop="label" />
      <el-table-column label="带货口碑" prop="reputation.score" />
      <el-table-column label="预估销量(件)" prop="volume" />
      <el-table-column label="预估销售额" prop="amount" />
      <el-table-column label="关键视频" prop="aweme_count" />
      <el-table-column label="关键直播" prop="room_count" />
    </el-table>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.per_page"
      @pagination="fetchList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { Capture, CaptureList } from '@/api/api2.js'
export default {
  name: 'Expert',
  components: {
    Pagination
  },
  data() {
    return {
      listQuery: {
        page: 1,
        per_page: 10,
        url: ''
      },
      list: [],
      total: 0,
      url: '',
      loading: false
    }
  },
  methods: {
    async handleRead() {
      this.loading = true
      const res = await Capture({ url: this.listQuery.url })
      if (res.code === 200) {
        this.listQuery.page = 1
        const list = await CaptureList(this.listQuery)
        if (list.code === 200) {
          this.loading = false
          this.list = list.data.data
          this.total = list.data.total
        } else {
          this.$message.error(list.msg)
          this.loading = false
        }
      } else {
        this.$message.error(res.msg)
        this.loading = false
      }
    },
    async fetchList() {
      this.loading = true
      const list = await CaptureList(this.listQuery)
      if (list.code === 200) {
        this.loading = false
        this.list = list.data.data
        this.total = list.data.total
      } else {
        this.$message.error(list.msg)
        this.loading = false
      }
    },
    handleQuery() {
      this.listQuery.page = 1
      this.fetchList()
    }
  }
}
</script>

<style lang="less">
  .u-flex {
    display: flex;
    padding: 20px;

    .button {
      background-color: #05c2c3;
      color: #fff;
      border: 1px solid #05c2c3;
    }
  }

  .app-expert {
    background-color: #fff;

    .expert-input {
      width: 400px;
      padding: 20px;
    }

    .avatar-name {
      display: flex;

      .avatar {
        flex-shrink: 0;
      }

      .name {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/expert/index.vue